import { Message } from 'element-ui'
import i18n from '@/lang'
export default function readExcel(files) { // 表格导入
  return new Promise(function(resove, reject) {
    if (files.length <= 0) { // 如果没有文件名
      reject(false)
      return false
    } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
      Message.error(i18n.t('excelTemplate.error.noExcel'))
      reject(false)
      return false
    }
    resove(true)
  })
}